if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      //these variables are for the sliding add to cart button at the header
      this.slidingAddToCartContainer = document.querySelector('.sliding-add-to-cart-container')
      this.productInfoBtnClose = document.querySelector('.product__info-wrapper-close-btn')
      if( this.slidingAddToCartContainer && this.productInfoBtnClose) {
        this.slidingAddToCartContainer.addEventListener('click', this.addClassFromList)
        this.productInfoBtnClose.addEventListener('click', this.removeClassFromList)
      }
      
      //these variables too are for the sliding add to cart button at the header
      this.addToCartObserve = document.querySelector('.main-product-qty-and-btn')
      this.addToCartObserveBounds = {};
      this.elementCont = document.getElementById('distance-container2')
      if (this.addToCartObserve && this.addToCartObserveBounds ) {
        this.createObserver();
      }

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }


    //this function is for the sliding add to cart button at the header
    addClassFromList() {
      document.querySelector('.product__info-wrapper.watch-distance').classList.add('product__info-wrapper-fix-to-screen')
    }

    //this function is for the sliding add to cart button at the header
    removeClassFromList() {
      document.querySelector('.product__info-wrapper.watch-distance').classList.remove('product__info-wrapper-fix-to-screen')
    }

    //create an observer for the add to cart button
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        if(entries[0].isIntersecting) {
          this.slidingAddToCartContainer.classList.remove('show-sliding-cart')
        }

        if(!entries[0].isIntersecting) {
          this.slidingAddToCartContainer.classList.add('show-sliding-cart')
        }
      }, {rootMargin: "-150px 0px 0px 0px"});
      
      observer.observe(this.addToCartObserve);

    }
    
    connectedCallback() {
      if (window.Rebuy && window.Rebuy._status !== 'initialized') {
        this.disableForm();
      }
    }

    disableForm() {
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    }

    enableForm() {
      this.submitButton.removeAttribute('aria-disabled');
      this.submitButton.classList.remove('loading');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const formData = new FormData(this.form);

      // Prevents adding duplicates to the cart
      if (window.Rebuy && window.Rebuy.Cart) {
        this.disableForm();

        if (formData.has('subscription_btn')) {
          const subscriptionBtn = formData.get('subscription_btn');
          const productId = formData.get('id');
          if (!subscriptionBtn || subscriptionBtn === 'null') return;

          fetch(window.Shopify.routes.root + 'products/' + subscriptionBtn + '.js')
            .then(response => response.json())
            .then(subscriptionProductData => {
              const variantId = subscriptionProductData.variants[0].id;
              console.log('subscriptionProductData', subscriptionProductData);

              window.Rebuy.Cart.addItem(
                {
                  quantity: 1,
                  id: variantId,
                  properties: {
                    parent_id: productId,
                    shipping_interval_frequency: '60',
                    shipping_interval_unit_type: 'days'
                  }
                }
              );
            });

                //in case you wanted to unfix the product__info section (where the add to cart button is located) after adding to cart
                //just uncomment this below
                document.querySelector('.product__info-wrapper.watch-distance').classList.remove('product__info-wrapper-fix-to-screen')
        }

        return; // Rebuy will automatically take care of adding the product to cart
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          setTimeout(() => {
            this.cart.open();
          }, 100);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

                  //in case you wanted to unfix the product__info section (where the add to cart button is located) after adding to cart
                  //just uncomment this below
                  document.querySelector('.product__info-wrapper.watch-distance').classList.remove('product__info-wrapper-fix-to-screen')
          
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
